import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { numify } from 'numify';
/////////////////////////////////////////////////////////////
import { Progress } from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';

export const LevelProgress: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/
	const { level, levelsRequeriments, levelProgress, levelName } =
		useCustomSelector((state) => state.counter);

	/*********************
	// #region States
	**********************/

	/*********************
	// #region Functions  
	**********************/

	/*********************
	// #region Template
	**********************/
	return (
		<Link to={'/levels'} className="col-span-3 flex flex-col">
			{level < levelsRequeriments.length && (
				<>
					<div className="flex justify-between items-center font-semibold">
						<p className="text-sm font-semibold">
							{t('dashboard.nextLevel')} :{' '}
							{level > levelsRequeriments.length - 1
								? levelsRequeriments.length
								: level + 1}
						</p>

						{levelsRequeriments[level] && (
							<p className="text-xs">
								{t('general.required')}:{' '}
								{numify(
									levelsRequeriments[level]?.requiredPoints
								)}
							</p>
						)}
					</div>
					<Progress value={levelProgress} className="bg-black my-2" />
				</>
			)}
			<div className="flex justify-between text-xs font-semibold">
				<p>{levelName}</p>
				<p>
					Lvl: {level}/{levelsRequeriments.length}
				</p>
			</div>
		</Link>
	);
};
